import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button as MuiButton, Typography } from "@mui/material";
import { Button } from "../../Atoms/Button";
import { Container } from "./style";


export const ScreenGreeting = ({
  title,
  subTitle = "",
  hasButton = false,
  hasBackButton = false,
  imgProperties = "",
  imgUrl = "",
  buttonTitle = undefined,
  handleClick = () => { },
  handleBack = () => { },
}) => {
  return (
    <Container>
      <div>
        {hasBackButton && (
          <MuiButton
            onClick={handleBack}
            startIcon={<ArrowBackIcon />}
            variant="text"
            sx={{ paddingLeft: 0, marginBottom: 1 }}
          >
            Voltar
          </MuiButton>
        )}
        <Typography variant="h4" gutterBottom>
          {title}
        </Typography>
        {subTitle && (
          <Typography variant="subtitle1" gutterBottom>
            {subTitle}
          </Typography>
        )}
      </div>
      {hasButton && (
        <div>
          <Button className="extra-button" onClick={handleClick}>{buttonTitle}</Button>
        </div>
      )}
      {!!imgProperties && (
        <div>
          <img
            src={imgUrl}
            alt="qrCode"
            style={{ width: imgProperties.width, height: imgProperties.height }}
          />
        </div>
      )}
    </Container>
  );
};

ScreenGreeting.propTypes = {};
